import Splide from '@splidejs/splide';

document.querySelectorAll('.js-instagram').forEach((carousel) => {
  const slider = new Splide(carousel, {
    arrows: false,
    pagination: true,
    fixedWidth: '363px',
    gap: 40,
    perMove: 1,
    breakpoints: {
      1366: {},
      1024: {
        fixedWidth: '300px',
        gap: 20,
      },
      767: {
        fixedWidth: '290px',
      },
    },
  });

  slider.mount();

  const prevButton = carousel.querySelector('.splide__nav--prev');
  const nextButton = carousel.querySelector('.splide__nav--next');

  const updateControls = () => {
    const isLoop = slider.options.type === 'loop';

    if (!isLoop) {
      if (prevButton) {
        prevButton.disabled = slider.index === 0;
      }
      if (nextButton) {

        const lastPossibleIndex = slider.length - slider.options.perPage;
        nextButton.disabled = slider.index >= lastPossibleIndex;
      }
    } else {
      if (prevButton) prevButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }
  };

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', () => slider.go('<'));
    nextButton.addEventListener('click', () => slider.go('>'));
  }

  slider.on('moved', updateControls);
  updateControls();
});
